import { DealerChangeLogDtoToEntity } from "src/app/features/DealerChangeLog/services/mappers/DealerChangeLogDtoToEntity";
import type { DealerChangeLogDto } from "src/app/features/DealerChangeLog/types/DealerChangeLogDto";
import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormQuery } from "../../../../../core/service/types/FormQuery";
import type { DealerChangeLogEntity } from "../../types/DealerChangeLogEntity";

const DealerChangeLogApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        DealerChangeLogLoad: builder.query<DealerChangeLogEntity, FormQuery>({
            providesTags: [ResourceName.DEALER_CHANGE_LOGS],
            query: (queryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.DEALER_CHANGE_LOGS}/${queryParams.entityId}`,
                    method: "GET",
                };
            },
            transformResponse: (response: DealerChangeLogDto, _) => {
                return DealerChangeLogDtoToEntity(response);
            },
        }),
    }),
});

export const { useDealerChangeLogLoadQuery } = DealerChangeLogApi;
